import { adButlerClient } from '@shared/js/api/adbutler';

export default {
	data() {
		return {
			adServerImageCache: new Map(),
		};
	},
	methods: {
		async getAdServerGraphicImage(graphicId, zoneId, format, keywords = []) {
			if (this.adServerImageCache.has(graphicId)) {
				return this.adServerImageCache.get(graphicId);
			}

			try {
				// the endpoint needs to be the current host because of cors limitation
				adButlerClient.endpoint = window.location.protocol + '//' + window.location.hostname + '/adserve/';
				const response = await adButlerClient.getAd(zoneId, this.adButlerLocale, format, keywords);

				if (!response.ok) {
					throw new Error(`Request failed with status ${response.status}`);
				}

				const data = await response.json();

				const imageUrl = data.placements?.placement_1?.image_url ?? null;

				this.adServerImageCache.set(graphicId, imageUrl);

				return imageUrl;
			} catch (error) {
				console.error('Unable to fetch ad butler graphic: ', error);
				return null;
			}
		},
	},
	computed: {
		adButlerLocale() {
			return window.locale === 'de' ? 'de-CH' : (window.locale + '-' + window.locale.toUpperCase());
		},
	},
};
